import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-overlays';
import { requestReport } from '../utility/rest';

// eslint-disable-next-line
const EMAIL_REGEX = new RegExp(`^[a-zA-Z0-9.!#$%&'*+\/=?^_\`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$`);

const RichiediReport = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const onChange = useCallback(e => setEmail(e.target.value), []);
  const closeModal = useCallback(() => setModalVisible(false), []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!EMAIL_REGEX.test(email)) {
      setError(true);
      console.warn('Invalid email');
      return;
    }
    setError();
    setLoading(true);
    setModalVisible(true);
    try {
      const result = await requestReport(email);
      console.log('Request report result: ', result);
      setEmail('');
    } catch (err) {
      console.error('Submit error: ', err);
      setModalVisible(false);
    }
    setLoading(false);
  }

  return (
    <form className="form" onSubmit={onSubmit}>
      <fieldset className="form__fieldset">
        <div className="row">
          <div className="col-md-12 col-lg-7 col-xl-8">
            <div style={{ position: "relative", zIndex: 0 }}>
              <div className={`form__textwrapper ${error ? 'failed' : ''}`}>
                <label htmlFor="email-report" className="form__label d-block">
                  <span className="d-none">E-mail</span>
                  <input id="email-report" type="email" name="email" value={email} placeholder="Inserisci mail"
                    onChange={onChange} className="form__text" />
                </label>
                {!!error && <div className="service-message"><FormattedMessage id="email-invalid" defaultMessage="Formato email non valido" /></div>}
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-5 col-xl-4 mt-md-3 mt-lg-0">
            <button className="btn-cta btn-style-2" disabled={loading}>
              Richiedi report
            </button>
          </div>
        </div>
      </fieldset>
      <Modal
        onHide={closeModal}
        aria-labelledby="modal-label"
        show={modalVisible}
        className="modal-box"
        renderBackdrop={props => <div {...props} className="modal-bg" />}
      >
        {!loading ?
          <p>
            Grazie per aver richiesto il report.<br/>
            Riceverai una email con il link per il download.
          </p> :
          <div className="lds-roller">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
          </div>
        }
      </Modal>
    </form>
  )
}

export default RichiediReport;